
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { ProviderModel } from '@alao-frontend/erp-services'

@Component
export default class ProvidersListStatic extends Vue {
  @Prop({ required: true, default: () => [], type: Array })
  readonly providers!: ProviderModel[]
}
